import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

function initialState() {
	return {
		base_url: process.env.VUE_APP_BASE_URL,
		contentLoading: false,
		mainNavOpen: false,
		searchOpen: false,
		popupOpen: false,
		popupContent: '',
		modalsVisible: {
			chooseTopic: false,
			savedInfo: false
		},
		recipientTypes: [],
		selectedRecipients: [],
		topics: [],
		save: null,
		savedContent: [],
		contentNotFound: false,
		apiError: false,
		analyticsCookies: ''
	}
}

export default new Vuex.Store({
	state: initialState,
	mutations: {
		contentLoading(state, boolean) {
			state.contentLoading = boolean;
		},
		mainNavOpen(state, boolean) {
			state.mainNavOpen = boolean;
		},
		searchOpen(state, boolean) {
			state.searchOpen = boolean;
		},
		setRecipientTypes(state, data) {
			state.recipientTypes = data;
		},
		setTopics(state, data) {
			state.topics = data;
		},
		setSave(state, data) {
			state.save = data;
		},
		setAnalyticsCookies(state, data) {
			state.analyticsCookies = data;
		},
		selectedRecipients(state, object) {
			state.selectedRecipients = object;
		},
		popupOpen(state, boolean) {
			state.popupOpen = boolean;
		},
		popupContent(state, object) {
			state.popupContent = object;
		},
		modalVisible(state, payload) {
			state.modalsVisible[payload.modal] = payload.boolean;
		},
		addSavedContent(state, values) {
			// Reset
			state.savedContent = [];
			values.forEach(function(value) {
				state.savedContent.push(value);
			});
		},
		contentNotFound(state, boolean) {
			state.contentNotFound = boolean;
		},
		apiError(state, boolean) {
			state.apiError = boolean;
		}
	},
	actions: {
		updateSave: ({
			commit
		}, data) => {
			commit('setSave', data);
			sessionStorage.setItem('save', data.uid);
		},
		updateSelectedRecipients: ({
			commit
		}, data) => {
			commit('selectedRecipients', data);
			sessionStorage.setItem('selectedRecipients', JSON.stringify(data));
		},
		removeSaveAndRecipients: ({
			commit
		}) => {
			commit('setSave', null);
			commit('selectedRecipients', []);
			commit('addSavedContent', []);
			sessionStorage.removeItem('selectedRecipients');
			sessionStorage.removeItem('save');
		},
		updateAnalyticsCookies: ({
			commit
		}, data) => {
			localStorage.setItem('analytics-cookies', data);

			if (data === 'on') {
				commit('setAnalyticsCookies', true);
			} else {
				commit('setAnalyticsCookies', false);
			}
		},
	}
});